module.exports = {"trip":"旅游","accommodation":"投宿"}